import React from 'react';
import SvgIcon from '@home/components/SvgIcon';
import type {
  TLayoutAiAnalysisType,
  TLayoutChartType,
  TLayoutTextType,
} from '@/pages/datalab/components/DashboardLayout/hooks';
import { useDblIntl } from '@/pages/datalab/utils/utils';
import './index.scss';

interface ITextBackgroundColor {
  hexa?: string;
  alpha?: string | number;
}

const DEFAULT_BACKGROUND_COLOR = '#ffffff';
const HEXA_ALPHA_REGEX = /^#[0-9a-fA-F]{8}$/;

/**
 * 统一透明色判定，兼容 alpha 字段和 8 位 Hex（AA 通道）两种数据格式。
 * 这样 TextDrag 自身样式和父层 react-grid-item 的透明联动可复用同一规则。
 */
const isTransparentBackground = (backgroundColor?: ITextBackgroundColor): boolean => {
  const alpha = Number(backgroundColor?.alpha);
  if (!Number.isNaN(alpha) && alpha <= 0) {
    return true;
  }

  const hexa = backgroundColor?.hexa;
  return Boolean(hexa && HEXA_ALPHA_REGEX.test(hexa) && hexa.endsWith('00'));
};

/**
 * 给 DashboardLayout 提供文本卡透明态判断：
 * 仅文本卡参与该逻辑，避免对图表/分析卡片产生副作用。
 */
export const isTransparentTextCard = (
  item: TLayoutChartType | TLayoutTextType | TLayoutAiAnalysisType,
): boolean => {
  if (item?.type !== 'text') {
    return false;
  }

  const backgroundColor = (item as TLayoutTextType & {
    backgroundColor?: ITextBackgroundColor;
  })?.backgroundColor;
  return isTransparentBackground(backgroundColor);
};

const TextDrag = (porps: any) => {
  const { data, getDelete, isEdit = true } = porps;
  const { dblFormatMessage } = useDblIntl('create_dashboard');
  const { text = '', backgroundColor } = data || {};
  const isTransparent = isTransparentBackground(backgroundColor);
  const cardStyle: React.CSSProperties = isTransparent
    ? {
      backgroundColor: 'transparent',
      padding: 0,
      border: 'none',
    }
    : {
      backgroundColor: backgroundColor?.hexa || DEFAULT_BACKGROUND_COLOR,
    };

  return (
    <div
      className="dbl-text-drag"
      style={cardStyle}
    >
      {/* 关闭按钮 */}
      {
        isEdit && <div
          className="dbl-text-drag-clonse"
          onClick={(e) => {
            e.stopPropagation();
            getDelete?.(data);
          }}
        >
          <SvgIcon type="clonse" />
        </div>
      }

      <div className='dbl-text-drag-flex'>
        {/* {isEdit && <SvgIcon type="drag-icon" className="dbl-text-drag-icon" />} */}
        <div className="dbl-text-drag-text">
          {text ? (
            <div dangerouslySetInnerHTML={{ __html: text }}></div>
          ) : (
            <div className="dbl-text-drag-grey">{dblFormatMessage('input')}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TextDrag;
